import { FC } from 'react';
import { Box, Card, Flex, Image, Text } from 'roo-ui/components';
import { qantasQff } from 'roo-ui/logos';
import { FormattedNumber } from 'components/Formatters';
import { BonusPointsDisclaimer } from 'components/Disclaimers';

const QffBonusCard: FC<{ bonusPoints?: number | string }> = ({ bonusPoints = 0 }) => {
  return bonusPoints ? (
    <Card px={4} py={5} mb={[5, 8]} data-testid="qff-bonus-points-card">
      <Flex alignItems="center" flexDirection={['column', 'row']}>
        <Image src={qantasQff} alt="Qantas Frequent Flyer Logo" mb={[4, 0]} width={114} />
        <Box ml={[0, 4]} data-testid="bonus-messaging">
          <Text>If you choose a Qantas Hotels credit voucher for your refund, we’ll award you</Text>
          <Text fontWeight="bold" data-testid="points-amount">
            {` ${FormattedNumber({ number: bonusPoints, decimalPlaces: 0 })} `}
            bonus Qantas Points
            <BonusPointsDisclaimer.Link />
          </Text>
          <Text> as a thank you.</Text>
        </Box>
      </Flex>
    </Card>
  ) : null;
};

export default QffBonusCard;
